import { jsx as _jsx } from "react/jsx-runtime";
import Item from "components/Emails/Item";
import UPDATE_EMAILS_HEADINGS from "mutations/emails/updateEmailsHeading";
import GET_EMAILS_HEADING from "queries/emails/getEmailsHeading";
const HeadingsItem = () => (_jsx(Item, { getQuery: GET_EMAILS_HEADING, getQueryDataName: "getEmailsHeading", itemName: "heading", updateMutation: UPDATE_EMAILS_HEADINGS }));
export default HeadingsItem;
